import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Tabs,
  Tab,
  IconButton,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import CreateCategoryGroupForm from "../components/PagesComponents/MenuManagement/Category/AddCategory";
import AddProductsForm from "../components/PagesComponents/MenuManagement/products/AddProductsForm";
import CategoryGroupTabs from "../components/PagesComponents/MenuManagement/Category/getCategory";
import ProductTabs from "../components/PagesComponents/MenuManagement/products/ProductTabs";
import CreateOfferForm from "../components/PagesComponents/MenuManagement/Offers/CreateOfferForm";
import OfferList from "../components/PagesComponents/MenuManagement/Offers/OfferList"; // ✅ مكون عرض العروض
import { getAllCategoryGroups } from "../services/menuPage";
import PrinterSettings from "../components/PagesComponents/Settings/PrinterSettings/PrinterSettings"; // ✅ استيراد المكون الجديد
import TaghezSetup from "../components/PagesComponents/Settings/Taghez/TaghezSetup"; // ✅ استيراد المكون الجديد
import Shiftname from "../components/PagesComponents/Settings/DailySessionAndShifts/Shiftname"; // ✅ Import Shiftname component
import ServicesandTaxTap from "../components/PagesComponents/Settings/ServicesandTaxSettingsTap/ServicesandTaxTap"; // ✅ استيراد المكون الجديد
import TaghezPrintSettingTap from "../components/PagesComponents/Settings/TaghezPrint/TaghezPrintSettingTap"; // استيراد مكون إعدادات طباعة التجهيز
import ExternalpagesTap from "../components/PagesComponents/Settings/ExternalpagesTap";
import BillOrderSettings from "../components/PagesComponents/Settings/BillOrderSettings"; // استيراد مكون ترتيب الفواتير
import BookingSettingsTap from "../components/PagesComponents/Settings/BookingSettingsTap"; // ✅ استيراد مكون BookingSettingsTap

// إضافة مكوّن بسيط لإعدادات الحجز داخل نفس الملف (يمكن استبداله بمكوّن منفصل لاحقًا)
const ReservationSettings = () => {
  const [enabled, setEnabled] = useState(true);
  const [maxGuests, setMaxGuests] = useState(10);
  const [bookingWindowDays, setBookingWindowDays] = useState(30);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      
    </Box>
  );
};

const Settings = () => {
  const [tabIndex, setTabIndex] = useState(() => {
    // جلب رقم التاب من اللوكال ستورج إذا كان موجوداً
    const savedTab = localStorage.getItem("settings_tab_index");
    return savedTab ? Number(savedTab) : 0;
  });

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
    localStorage.setItem("settings_tab_index", newValue); // حفظ رقم التاب في اللوكال ستورج
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>⚙️ الإعدادات</Typography>

      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab label="إعدادات عامة" />
          <Tab label="إعدادات الطابعة" />
          <Tab label="شاشة التجهيز" />
          <Tab label="طباعه التجهيز" /> {/* ✅ التاب الجديد */}
          <Tab label="اليومية والشيفتات" />
          <Tab label="إعدادات الخدمات والضرائب" />
          <Tab label="صفحات خارجية" />
          <Tab label="إعدادات الحجز" /> {/* ✅ تاب الحجز المضاف */}
          {/* <Tab label="مركز التنبيهات" /> */} {/* ❌ تم إلغاء التاب */}
          <Tab label="ترتيب الفواتير" /> {/* ✅ التاب الجديد */}
        </Tabs>
      </Paper>

      {/* ✅ إعدادات عامة */}
      {tabIndex === 0 && (
        <Box>
          <TextField fullWidth label="اسم المطعم" variant="outlined" margin="dense" />
          <TextField fullWidth label="العنوان" variant="outlined" margin="dense" />
          <TextField fullWidth label="طرق الدفع المتاحة" variant="outlined" margin="dense" />
          <Button variant="contained" color="primary" sx={{ mt: 2 }}>
            حفظ التعديلات
          </Button>
        </Box>
      )}

      {/* ✅ إعدادات الطابعة */}
      {tabIndex === 1 && (
        <Box>
          <Box sx={{ mt: 4 }}>
            <PrinterSettings /> {/* ✅ Render PrinterSettings component */}
          </Box>
        </Box>
      )}

      {/* ✅ شاشة التجهيز */}
      {tabIndex === 2 && (
        <Box>
          <TaghezSetup /> {/* ✅ Render TaghezSetup component */}
        </Box>
      )}

      {/* ✅ طباعه التجهيز */}
      {tabIndex === 3 && (
        <Box>
          <Typography variant="h6">🖨️ طباعه التجهيز</Typography>
          <TaghezPrintSettingTap />
        </Box>
      )}

      {/* ✅ اليومية والشيفتات */}
      {tabIndex === 4 && (
        <Box>
          <Typography variant="h6">📅 اليومية والشيفتات</Typography>
          <Shiftname /> {/* ✅ Render Shiftname component */}
        </Box>
      )}

      {/* ✅ إعدادات الخدمات والضرائب */}
      {tabIndex === 5 && (
        <Box>
          <Typography variant="h6">💼 إعدادات الخدمات والضرائب</Typography>
          <ServicesandTaxTap /> {/* ✅ عرض المكون هنا */}
        </Box>
      )}

      {/* ✅ صفحات خارجية */}
      {tabIndex === 6 && (
        <Box>
          <Typography variant="h6">🌐 صفحات خارجية</Typography>
          <ExternalpagesTap />
        </Box>
      )}

      {/* ✅ إعدادات الحجز */}
      {tabIndex === 7 && (
        <Box>
          <BookingSettingsTap />
        </Box>
      )}

      {/* ✅ ترتيب الفواتير */}
      {tabIndex === 8 && (
        <Box>
          <Typography variant="h6">🔢 ترتيب الفواتير</Typography>
          <BillOrderSettings />
        </Box>
      )}
    </Box>
  );
};

export default Settings;
